import { Question } from "./QuestionTypes"

export const questions: Question[][] = [
	[
		{
			challenge: 'What year did Lady Gaga debut the "Meat Dress"?',
			content: "meat-dress.jpg",
			choices: [{ option: "2009" }, { option: "2010", correct: true }, { option: "2011" }, { option: "2012" }],
			category: "art",
			citation: "https://en.wikipedia.org/wiki/Meat_dress_of_Lady_Gaga",
		},
		{
			challenge: "What does the keyboard shortcut Ctrl+Shift+T do in most web browsers?",
			answer: "Re-open the last closed tab",
			choices: [
				{ option: "Open the browser task manager" },
				{ option: "Open the developer tools" },
				{ option: "Re-open the last-closed tab", correct: true },
				{ option: "Nothing" },
			],
			category: "tech",
		},
		{
			challenge: "What is the name of the pharoah believed to have been entombed in the Great Pyramid of Giza?",
			choices: [
				{ option: "Imhotep" },
				{ option: "Khufu", correct: true },
				{ option: "Ramesses" },
				{ option: "Tutankhamun" },
			],
			reveal: "khufu.jpg",
			category: "world",
		},
		{
			challenge: "When did the fire at the southside Tim Hortons occur?",
			category: "local",
			choices: [
				{ option: "April 4th, 2021", correct: true },
				{ option: "April 28th, 2021" },
				{ option: "May 9th, 2021" },
				{ option: "June 2nd, 2021" },
			],
			citation: "https://www.terracestandard.com/news/fire-at-terrace-tim-hortons-on-keith-ave-no-injuries/",
			content: "tim-hortons-fire.jpg",
		},
		// {
		// 	challenge: "What is the typical incubation period of rabies?",
		// 	category: "health",
		// 	choices: [
		// 		{ option: "6-48 hours" },
		// 		{ option: "3-14 days" },
		// 		{ option: "1-52 weeks", correct: true },
		// 		{ option: "4-24 months" },
		// 	],
		// 	citation: "https://www.who.int/en/news-room/fact-sheets/detail/rabies",
		// },
		{
			challenge: "What animal is the primary transmitter of rabies to humans?",
			category: "health",
			choices: [
				{ option: "Bats", data: 0 },
				{ option: "Dogs", correct: true, data: 99 },
				{ option: "Humans", data: 0 },
				{ option: "Mosquitoes", data: 0 },
			],
			percentage: true,
			citation: "https://www.who.int/en/news-room/fact-sheets/detail/rabies",
		},
		{
			challenge: 'What does the word "obverse" mean?',
			category: "literature",
			choices: [
				{ option: "Absent" },
				{ option: "As a result of" },
				{ option: "Front or principal surface of", correct: true },
				{ option: "Predisposed to avoid" },
			],
			citation: "https://www.dictionary.com/browse/obverse",
		},
		{
			category: "film",
			challenge: "What class of starship is this?",
			content: "galaxy-class.png",
			reveal: "galaxy-class.mp4",
			choices: [
				{ option: "Constitution Class" },
				{ option: "Excelsior Class" },
				{ option: "Galaxy Class", correct: true },
				{ option: "Sovereign Class" },
			],
		},
		{
			challenge: "Approximately how many km of railroad are there in Canada?",
			choices: [
				{ option: "25,000" },
				{ option: "50,000", correct: true },
				{ option: "75,000" },
				{ option: "100,000" },
			],
			category: "industry",
			citation: "https://railwaysuppliers.ca/english/industry/industry-information.html/industry-statistics",
		},
		// {category: "puzzle", challenge: "4a + 5b = 2c, 2a + 3b = c, a = ?", answer: "2a = c - 3b, a = 4(c-3b)/2, 2c-12b+4b=2c"},
		{
			category: "literature",
			challenge: 'Who coined the term "meme"?',
			choices: [
				{ option: "Carl Sagan" },
				{ option: "Donald Trump" },
				{ option: "Pewdiepie" },
				{ option: "Richard Dawkins", correct: true },
			],
			reveal: "selfish-gene-quote.png",
		},
		{
			challenge: "Which region has the most top-10 tallest buildings* in the world?",
			choices: [
				{ option: "Americas", data: 1 },
				{ option: "Asia", data: 7, correct: true },
				{ option: "Europe", data: 0 },
				{ option: "Middle East", data: 2 },
			],
			category: "world",
			citation: "https://en.wikipedia.org/wiki/List_of_tallest_buildings",
			reveal: "tallest-buildings-coloured.png",
		},
		{
			challenge: "Since 2010, what percentage of Mount Everest climbers have died attempting to summit?",
			choices: [{ option: "<1%", correct: true }, { option: "1-3%" }, { option: "3-10%" }, { option: "10-20%" }],
			citation: "https://www.bbc.com/news/world-47418215",
			reveal: "everest-deaths.png",
			category: "world",
		},
		{
			challenge: "What comic series is this?",
			content: "xkcd.png",
			choices: [
				{ option: "The Oatmeal" },
				{ option: "Penny Arcade" },
				{ option: "Saturday Morning Breakfast Cereal" },
				{ option: "XKCD", correct: true },
			],
			category: "art",
		},
		{
			challenge: "Instagram Reels is analogous to YouTube ____",
			choices: [{ option: "Clips" }, { option: "Connect" }, { option: "Now" }, { option: "Shorts", correct: true }],
			category: "tech",
			reveal: "youtube-shorts.jpg",
			citation: "https://blog.youtube/news-and-events/building-youtube-shorts/",
		},
		{
			challenge: "A barleycorn is a measure of what?",
			choices: [
				{ option: "Density" },
				{ option: "Length", correct: true },
				{ option: "Volume" },
				{ option: "Weight" },
			],
			category: "industry",
			citation: "https://en.wikipedia.org/wiki/Barleycorn_(unit)",
			reveal: "english-length-units.svg",
		},
		{
			challenge: "Which plane was not prominent in World War II?",
			choices: [{ option: "Spitfire" }, { option: "Yak-1" }, { option: "F-4", correct: true }, { option: "Zero" }],
			category: "tech",
			reveal: "f4-phantom.jpg",
		},
		{
			challenge: "What is black's best move (remember, the board is oriented from black's perspective!)",
			choices: [{ option: "Bd5" }, { option: "g5" }, { option: "Qd1+", correct: true }, { option: "Qxc1+" }],
			category: "puzzle",
			content: "chess2.png",
			reveal: "chess2b.png",
		},
		{
			challenge:
				"What was the inflation-adjusted change in China's GDP from 2010 to 2020 according to the World Bank?",
			citation: "https://data.worldbank.org/indicator/NY.GDP.MKTP.KD?locations=CN",
			category: "economics",
			choices: [{ option: "94%", correct: true }, { option: "144%" }, { option: "229%" }, { option: "313%" }],
			reveal: "china-gdp.png",
		},
		{
			challenge: "Which candidate got the THIRD-most votes in Bulkley-Stikine in the latest federal election?",
			choices: [
				{ option: "Claire Rattee", data: 12885 },
				{ option: "Jody Craven", data: 2794, correct: true },
				{ option: "Lakhwinder Jhaj", data: 2790 },
				{ option: "Taylor Bachrach", data: 15100 },
			],
			category: "local",
			reveal: "jody-craven.jpg",
			citation: "https://newsinteractives.cbc.ca/elections/federal/2021/results/",
		},
		{
			challenge: "What is a demonym?",
			choices: [
				{ option: 'A label for a group of people, eg. "European"', correct: true },
				{ option: "A proof of concept, first draft, or prototype" },
				{ option: "One per million" },
				{ option: "The offspring of a nymph and demon" },
			],
			category: "literature",
			citation: "https://www.dictionary.com/browse/demonym",
		},
		{
			challenge: "Money can be withdrawn tax-free from an RRSP under what two government initiatives?",
			choices: [
				{ option: "CCA and HBP" },
				{ option: "CCA and LIRA" },
				{ option: "LIRA and LLP" },
				{ option: "LLP and HBP", correct: true },
			],
			category: "economics",
			citation:
				"https://www.canada.ca/en/revenue-agency/services/tax/individuals/topics/rrsps-related-plans/making-withdrawals/home-buyers-plan-lifelong-learning-plan-withdrawals.html",
		},
	],
	[
		{
			challenge: "Emmy Award trophies feature a woman holding a what?",
			category: "film",
			answer: "Atom",
			reveal: "emmy.jpg",
		},
		{
			challenge: "Who is depicted on this old $5 banknote?",
			answer:
				"Edward Albert Christian George Andrew Patrick David Windsor (Prince of Wales, later King Edward VIII)",
			category: "national",
			content: "prince-edward.jpg",
			citation:
				"https://www.bankofcanadamuseum.ca/complete-bank-note-series/1935-first-series/first-series-5-dollars/",
		},
		{
			challenge: 'On a 12-hour clock, what Latin phrase does "p.m." stand for?',
			answer: "Post meridiem (meaning after midday)",
			category: "world",
		},
		{
			challenge: "What is the name of this museum?",
			category: "national",
			content: "canadian-museum-of-human-rights.jpg",
			answer: "Canadian Museum of Human Rights",
			citation: "https://www.insider.com/museum-staff-was-told-not-to-show-gay-content-to-school-groups-2020-6",
		},
		// {
		// 	category: "world",
		// 	challenge: "What is the name of the Huawei CFO recently released following extradition proceedings in Canada?",
		// 	content: "meng-wanzhou.jpg",
		// 	answer: "Meng Wanzhou (孟晚舟)",
		// },
		// {
		// 	challenge: "Who is depicted in this painting?",
		// 	category: "art",
		// 	content: "princess-elizabeth.jpg",
		// 	answer: "Princess (now Queen) Elizabeth",
		// },
		// {
		// 	challenge: "What is this building called?",
		// 	content: "taipei-101.jpg",
		// 	category: "world",
		// 	answer: "Taipai 101",
		// 	citation: "https://www.taipei-101.com.tw/",
		// 	reveal: "taipei-101.svg",
		// },
		// {
		// 	challenge: "What city is this?",
		// 	content: "seoul.jpg",
		// 	category: "world",
		// 	citation: "https://www.lwt.co.kr/en/main/main.do",
		// 	reveal: "seoul-map.png",
		// 	answer: "Seoul (and the Lotte World Tower)",
		// },
		// {
		// 	challenge:
		// 		"An object is dropped from a height of 1 km above the surface of the earth, in a vacuum.  After how many seconds will it hit bottom?",
		// 	answer: "d=vt, v=at/2, d=(at^2)/2, 1000 = (9.8t^2)/2, t = sqrt(2000/9.8), t=14.3",
		// 	category: "science",
		// },
		{
			challenge: "The odds of rolling the same number on all of three standard dice are 1 in...",
			answer: "36",
			category: "philosophy",
			citation:
				"https://www.vedantu.com/question-answer/in-a-single-throw-of-three-dice-find-the-class-12-maths-cbse-5f71d5eacb93694864d6ef80",
		},
		// { challenge: "What song is this?", answer: "Mad World", category: "music" },
		{
			challenge: "What car company logo is this?",
			answer: "Mercury",
			category: "tech",
			content: "mercury.svg",
			reveal: "mercury.png",
		},
		// {
		// 	challenge: "Who is the current US Secretary of State?",
		// 	category: "world",
		// 	reveal: "antony-blinkin.jpg",
		// 	answer: "Antony Blinkin",
		// 	citation: "https://en.wikipedia.org/wiki/United_States_Secretary_of_State",
		// },
		{
			challenge: "What is British Columbia's official flower?",
			answer: "(Pacific) Dogwood",
			category: "life",
			reveal: "dogwood.jfif",
			citation: "https://www2.gov.bc.ca/gov/content/governments/celebrating-british-columbia/symbols-of-bc",
		},
		{
			challenge: "What river runs through the Grand Canyon?",
			answer: "Colorado River",
			content: "grand-canyon.jpg",
			category: "world",
		},
		{
			challenge: "Android Auto is analagous to Apple ____",
			answer: "Carplay",
			content: "carplay.jpg",
			category: "tech",
		},
		{
			challenge: "Who was Prime Minister of the United Kingdom at the onset of World War II?",
			content: "neville-chamberlain2.jpg",
			answer: "Neville Chamberlain",
			reveal: "neville-chamberlain.jpg",
			category: "world",
		},
		{
			challenge: "What percentage of African residents have been fully vaccinated against COVID-19 ±5%?",
			tolerance: 5,
			answer: 4.96,
			category: "health",
			reveal: "covid-africa.png",
			citation: "https://africacdc.org/covid-19-vaccination/",
			percentage: true,
		},
		{
			challenge: "Which of the red boxes covers Castlegar?",
			answer: "Bottom Right",
			content: "castlegar-hidden.png",
			reveal: "castlegar-reveal.png",
			category: "local",
			notransition: true,
		},
		// {
		// 	challenge: "In what decade was the Empire State Building completed?",
		// 	answer: 1931,
		// 	content: "empire-state-building.jpg",
		// 	category: "industry",
		// },
		{
			challenge: "How many pixels wide is a 1080p monitor?",
			answer: 1920,
			category: "tech",
			reveal: "resolutions.png",
		},
		{
			challenge: "The Brooklyn Bridge joins the boroughs of Brooklyn and ____",
			answer: "Manhattan",
			reveal: "brooklyn-bridge.png",
			category: "world",
		},
		// { challenge: "This aircraft is an F-____", answer: "14", content: "f-14.jpg", category: "tech" },
		// {
		// 	challenge: "What is this ship, the first of its class, called?",
		// 	answer: "(HMCS) Harry DeWolf",
		// 	content: "harry-dewolf.jpg",
		// 	category: "national",
		// },
		// {
		// 	category: "national",
		// 	challenge: 'What are the last names of the "Two Michaels" recently released from China?',
		// 	answer: ["Spavor", "Kovrig"],
		// 	content: "two-michaels.jpg",
		// 	citation: "https://en.wikipedia.org/wiki/Detention_of_Michael_Spavor_and_Michael_Kovrig",
		// },
		{
			challenge: "What company is the prime contractor constructing Terrace's new hospital?",
			answer: "PCL Constructors Westcoast Inc. (PCL)",
			category: "industry",
			reveal: "pcl-construction.webp",
			citation: "https://www.infrastructurebc.com/projects/projects-under-construction/mills-memorial-hospital/",
		},
		{
			challenge: 'What does the m stand for in "mRNA Vaccine?"',
			answer: "Messenger",
			category: "health",
			citation: "https://en.wikipedia.org/wiki/MRNA_vaccine",
			reveal: "mrna.png",
		},
		{
			challenge: "What country is Damascus the capital of?",
			category: "world",
			answer: "Syria",
			citation: "https://en.wikipedia.org/wiki/Damascus",
			reveal: "syria.svg",
		},
		{
			challenge: "Who is the current CEO of Microsoft?",
			answer: "Satyanarayana (Satya) Nadella (సత్యనారాయణ నాదెళ్ల)",
			reveal: "satya-nadella.jpg",
			category: "industry",
		},
		// {
		// 	challenge: "What are Justin Trudeau's middle names?",
		// 	answer: ["Pierre", "James"],
		// 	category: "national",
		// 	content: "justin-trudeau.jpg",
		// },
		{
			challenge:
				'Spelled exactly, what is the name of the short film cartoon series that concluded with "That\'s all Folks!"',
			answer: "Looney Tunes",
			content: "looney-tunes-outro.png",
			reveal: "looney-tunes.png",
			category: "film",
			// {option: "Luney Toons"}, {option: "Loony Toons"}, {option: "Luney Tunes"}, {option: "Looney Tunes", correct: true}
		},
		{
			challenge: "According to Health Canada, what internal temperature should ground beef reach when cooked? (°F)",
			answer: "71°C / 160°F",
			// choices: [
			// 	{ option: "66°C / 150°F" },
			// 	{ option: "71°C / 160°F", correct: true },
			// 	{ option: "77°C / 170°F" },
			// 	{ option: "82°C / 180°F" },
			// ],
			citation:
				"https://www.canada.ca/en/health-canada/services/general-food-safety-tips/safe-internal-cooking-temperatures.html",
			category: "health",
		},
	],
	[
		// {
		// 	challenge: "What movie is this?",
		// 	category: "film",
		// 	content: "ad-astra.mp4",
		// 	reveal: "ad-astra.jpg",
		// 	answer: "Ad Astra",
		// 	fullscreen: true,
		// },
		{
			challenge: "What movie is this?",
			category: "film",
			content: "vertigo.mp4",
			reveal: "vertigo.jpg",
			answer: "Vertigo",
			fullscreen: true,
		},
		{
			challenge: "What movie is this?",
			category: "halloween",
			content: "ernest-scared-stupid.mp4",
			reveal: "ernest-scared-stupid.jpg",
			answer: "Ernest Scared Stupid",
			fullscreen: true,
		},
		{
			challenge: "What movie is this?",
			category: "film",
			content: "dragon-tattoo.mp4",
			reveal: "dragon-tattoo.jpg",
			answer: "The Girl With the Dragon Tattoo",
			fullscreen: true,
		},
		{
			challenge: "What movie is this?",
			category: "film",
			content: "city-slickers.mp4",
			reveal: "city-slickers.jpg",
			answer: "City Slickers",
			fullscreen: true,
		},
		{
			challenge: "What movie is this?",
			category: "film",
			content: "knives-out.mp4",
			reveal: "knives-out.jfif",
			answer: "Knives Out",
			fullscreen: true,
		},
		// {
		// 	challenge: "What movie is this?",
		// 	category: "film",
		// 	content: "final-fantasy.mp4",
		// 	reveal: "final-fantasy.jpg",
		// 	answer: "Final Fantasy: The Spirits Within",
		// 	fullscreen: true,
		// },
		{
			challenge: "What movie is this?",
			category: "film",
			content: "sunshine.mp4",
			reveal: "sunshine.jpg",
			answer: "Sunshine",
			fullscreen: true,
		},
		{
			challenge: "Name the TV series",
			category: "film",
			content: "squid-game.mp4",
			reveal: "squid-game.jpg",
			fullscreen: true,
			answer: "Squid Game",
		},
		{
			challenge: "Name the TV series",
			category: "film",
			content: "lucifer.mp4",
			reveal: "lucifer.jpg",
			fullscreen: true,
			answer: "Lucifer",
		},
		{
			challenge: "What movie is this?",
			category: "film",
			content: "the-naked-gun.mp4",
			reveal: "the-naked-gun.jpg",
			answer: "The Naked Gun",
			fullscreen: true,
		},
		{
			challenge: "What movie is this?",
			category: "film",
			content: "the-prestige.mp4",
			reveal: "the-prestige.jpg",
			answer: "The Prestige",
			fullscreen: true,
		},
		// {
		// 	challenge: "What movie is this?",
		// 	category: "film",
		// 	content: "galaxy-quest.mp4",
		// 	reveal: "galaxy-quest.jpg",
		// 	answer: "Galaxy Quest",
		// 	fullscreen: true,
		// },
		{
			challenge: "What is the name of the singing character?",
			category: "film",
			content: "pinkie-pie.mp4",
			answer: "Pinkie Pie",
			reveal: "pinkie-pie.png",
			fullscreen: true,
		},
		// {
		// 	challenge: "Name every song you recognize from this 1-minute mashup",
		// 	category: "music",
		// 	content: "pd2015.2-1.mp4",
		// 	answer: [
		// 		"Ayo",
		// 		"Bitch I'm Madonna",
		// 		"Black Magic",
		// 		"Doing It",
		// 		"Good For You",
		// 		"How Deep is Your Love",
		// 		"I Want You to Know",
		// 		"Love Me Like You Do",
		// 		"Pretty Girls",
		// 		"This Summer's Gonna Hurt",
		// 		"Wildest Dreams",
		// 		"You're On",
		// 	],
		// 	reveal: "pd2015.2-1a.mp4",
		// 	fullscreen: true,
		// 	citation: "http://canadankim.com/pop-danthology-2015/",
		// },
		{
			challenge: "Who is handing out the money?",
			category: "film",
			content: "mrbeast.mp4",
			reveal: "mrbeast.jpg",
			answer: "MrBeast (Jimmy Donaldson)",
			fullscreen: true,
		},
		{
			challenge: "Name the song",
			category: "music",
			content: "she-hates-me.mp4",
			reveal: "she-hates-me-reveal.mp4",
			answer: "She Hates Me",
		},
		{
			challenge: "Name the song",
			category: "music",
			content: "right-here-right-now.mp4",
			reveal: "right-here-right-now-reveal.mp4",
			answer: "Right Here, Right Now",
		},
		{
			challenge: "What song, what decade?",
			category: "music",
			content: "rappers-delight.mp4",
			answer: ["Rapper's Delight", "1979"],
		},
		{
			challenge: "What song, what decade?",
			category: "music",
			content: "aint-no-sunshine.mp4",
			reveal: "aint-no-sunshine-reveal.mp4",
			answer: ["Ain't No Sunshine", "1971"],
		},
		{
			challenge: "What song, what decade?",
			category: "music",
			content: "hit-the-road-jack.mp4",
			reveal: "hit-the-road-jack-reveal.mp4",
			answer: ["Hit the Road Jack", "1962"],
		},
	],
]

// need music
// more TV less movies
// test laptop output
